<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div slot="content" class="content d-flex flex-row">
      <div class="tabs">
        <van-swipe
          ref="tabs"
          class="tabs"
          :height="data.length>=3?220/3:220/data.length"
          vertical
          :loop="false"
          :show-indicators="false"
          :autoplay="0"
          @change="tabChange"
        >
          <van-swipe-item
            class="tabSwiper flex-center"
            v-for="(item,index) in data"
            :key="index"
            @click="tabClick(index)"
          >
            <div
              class="tab flex-center rotate"
              :style="{width:(data.length>=3?220/3:220/data.length)+'px'}"
              :class="{defaultTab:swiperIndex!=index,currentTab:swiperIndex==index}"
            >{{item.title}}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="swipers">
        <van-swipe
          ref="swipers"
          class="swipe"
          width="220"
          @change="swiperChange"
          :show-indicators="false"
          :autoplay="0"
          :loop="false"
        >
          <van-swipe-item v-for="(imgItem,imgIndex) in data" :key="imgIndex" class="flex-center">
            <van-image
              @click="navToDetailPage(imgItem,imgIndex)"
              class="swipe-image"
              :class="{bigImage:swiperIndex==imgIndex,smallImage:swiperIndex!=imgIndex,'car-item-radius':pattern.showImgBorderRadius}"
              :src="imgItem.src"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Array,
      default: () => [
        {
          src: 'https://res.zhifu88.cn/alachuang/755320200508174011/default.png',
          name: '标题1',
          navTo: ''
        }, {
          src: 'https://res.zhifu88.cn/alachuang/755320200508174011/default.png',
          name: '标题2',
          navTo: ''
        },
      ]
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: false,
          showRightPadding: false,
          showTopPadding: false,
          showBottomPadding: false,
          showImgBorderRadius: true,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,0)',
        }
      }
    },
  },
  data () {
    return {
      swiperIndex: 0
    };
  },
  methods: {
    swiperChange (index) {
      this.swiperIndex = index;
      this.$refs.tabs.swipeTo(index)
    },
    tabChange (index) {
      this.swiperIndex = index;
      this.$refs.swipers.swipeTo(index)
    },
    tabClick (index) {
      this.swiperIndex = index;
      this.$refs.swipers.swipeTo(index)
    },
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}
.content {
  width: 100%;
  height: 220px;
}
.tabs {
  width: 50px;
  height: 100%;
}
.tabSwiper {
  position: relative;
}
.rotate {
  transform: rotate(-90deg);
  transform-origin: center;
}
.tab {
  position: absolute;
  height: 50px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
}
.defaultTab {
  color: grey;
}
.currentTab {
  color: black;
  font-weight: bold;
}
.swipers {
  width: calc(100% - 50px);
  height: 100%;
}
.swipe {
  height: 100%;
}
.swipe-image {
  transition: all 0.3s;
}
.width {
  width: 10px;
}
.bigImage {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.smallImage {
  width: 90%;
  height: 90%;
  overflow: hidden;
}
.car-item-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.car-item-radius {
  border-radius: 12px;
  overflow: hidden;
}
</style>
